var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_28363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 16.3337V7.00033C22.1667 5.71699 21.1167 4.66699 19.8334 4.66699H3.50008C2.21675 4.66699 1.16675 5.71699 1.16675 7.00033V16.3337C1.16675 17.617 2.21675 18.667 3.50008 18.667H19.8334C21.1167 18.667 22.1667 17.617 22.1667 16.3337ZM11.6667 15.167C9.73008 15.167 8.16675 13.6037 8.16675 11.667C8.16675 9.73033 9.73008 8.16699 11.6667 8.16699C13.6034 8.16699 15.1667 9.73033 15.1667 11.667C15.1667 13.6037 13.6034 15.167 11.6667 15.167ZM26.8334 8.16699V21.0003C26.8334 22.2837 25.7834 23.3337 24.5001 23.3337H4.66675V21.0003H24.5001V8.16699H26.8334Z",
    fill: "#5182EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_28363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.2e5da832d474a2ada41d080735a1bb69.svg";
export { ForwardRef as ReactComponent };